<div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
  <div>
    <h5 class="mb-1 fw-bold">Production Inventory</h5>
    <span class="sub-text">Overview of current stock levels</span>
  </div>
  <div class="d-flex align-items-center gap-2">
    <input
      type="text"
      class="form-control"
      placeholder="Search product..."
      [formControl]="searchControl"
      style="width: 220px" />
    <!--    <button-->
    <!--      class="btn btn-soft-primary d-flex align-items-center gap-1"-->
    <!--      (click)="exportReport()"-->
    <!--      [disabled]="isExporting || isDataLoading">-->
    <!--      @if (isExporting) {-->
    <!--        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>-->
    <!--        Exporting...-->
    <!--      } @else {-->
    <!--        <i class="bi bi-download me-1"></i>-->
    <!--        Export Report-->
    <!--      }-->
    <!--    </button>-->
  </div>
</div>

@if (isDataLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  @if (groupedInventory.length === 0) {
    <app-info-alert>No production material available to display in stock</app-info-alert>
  } @else {
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="bg-light">
          <tr>
            <th class="border-0">Product</th>
            <th class="border-0">Packaging</th>
            <th class="border-0 text-center">Batch</th>
            <th class="border-0 text-center">MFG Date</th>
            <th class="border-0 text-center">EXP Date</th>
            <th class="border-0 text-center">Boxes</th>
            <th class="border-0 text-center">Units</th>
            <th class="border-0 text-center">Warehouse</th>
          </tr>
        </thead>
        <tbody>
          @for (group of groupedInventory; track group.product_name) {
            @for (row of group.rows; track $index; let isFirst = $first) {
              <tr>
                @if (isFirst) {
                  <td class="fw-semibold align-middle" [attr.rowspan]="group.rows.length">
                    {{ group.product_name }}
                  </td>
                }
                <td>{{ row.packaging }}</td>
                <td class="text-center text-muted">{{ row.batch }}</td>
                <td class="text-center text-muted">{{ row.mfg_date }}</td>
                <td class="text-center text-muted">{{ row.exp_date }}</td>
                <td class="text-center font-monospace">
                  <span class="fw-bold" [class.text-success]="+row.boxes > 0" [class.text-danger]="+row.boxes <= 0">
                    {{ row.boxes }}
                  </span>
                </td>
                <td class="text-center font-monospace text-muted">{{ row.stock }}</td>
                <td class="text-center">
                  <span class="badge app-badge badge-soft-primary">{{ row.warehouse_name | titlecase }}</span>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }

  @if (groupedInventory.length > 0) {
    <div class="mt-4">
      <app-pagination
        [currentPage]="currentPage"
        [totalCount]="totalCount"
        [pageSize]="10"
        [hasNextPage]="hasNextPage"
        [hasPreviousPage]="hasPreviousPage"
        (pageChange)="onPageChange($event)"></app-pagination>
    </div>
  }
}
